import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteVehicle = createAsyncThunk(
  'listVehicles/fetchDeleteVehicle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteVehicle(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteVehicleSlice = createSlice({
  name: 'vehicles/delete',
  initialState,
  reducers: {
    resetDeleteVehicle: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteVehicle.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteVehicle.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteVehicle.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteVehicleSlice.reducer
export const { resetDeleteVehicle } = deleteVehicleSlice.actions
